import { User } from '@atom-learning/icons'
import * as React from 'react'

import { Icon } from '../icon/Icon'

export const AvatarPlaceholder = () => {
  return (
    <div className="relative size-full">
      <Icon is={User} className="size-full" />
    </div>
  )
}
